import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';

import { Navigation } from '../';
import { fetchResults } from '../../../../../../ducks/results';
import { paginate, setForm } from '../../../../../form/form-duck';
import { contextShape } from '../../../../posting-header.proptypes';
import { getSearchPager } from '../../navigation-selectors';

const mapStateToProps = ({ search }, props) => getSearchPager(search, props);
const mapDispatchToProps = { fetchResults, paginate, setForm };

export const SearchNavigation = ({
  context,
  className,
  cursor,
  searchQuery,
  setForm,
  fetchResults,
  paginate,
  location,
}) => {
  const { shouldFetchNextPage, currentPage } = cursor;

  useEffect(() => {
    const isNextJob = location.search.includes('sc_o=jobs_next_job_link');

    if (searchQuery && !isNextJob) {
      setForm(searchQuery);
      fetchResults();
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (shouldFetchNextPage) {
      paginate(currentPage + 1);
      fetchResults({ shouldAppendResults: true });
    }
  }, [shouldFetchNextPage]); // eslint-disable-line react-hooks/exhaustive-deps

  return Boolean(searchQuery) && <Navigation context={context} className={className} />;
};

SearchNavigation.propTypes = {
  cursor: PropTypes.shape({
    isInitialised: PropTypes.bool.isRequired,
    shouldFetchNextPage: PropTypes.bool,
    currentPage: PropTypes.number,
  }).isRequired,
  context: contextShape,
  searchQuery: PropTypes.shape({
    keywords: PropTypes.string,
    location: PropTypes.string,
    radius: PropTypes.string,
    limit: PropTypes.string,
    offset: PropTypes.string,
  }),
  fetchResults: PropTypes.func.isRequired,
  paginate: PropTypes.func.isRequired,
  setForm: PropTypes.func.isRequired,
  className: PropTypes.string,
  location: PropTypes.object.isRequired,
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(SearchNavigation));
